import { atom } from "jotai";

// True while GET /organizations/{id}/bank-accounts is in flight (#296). The list itself
// stays in the consuming component's state — it is per-surface, lazily fetched data, not
// app-global truth.
export const isFetchingBankAccountsAtom = atom<boolean>(false);
